import { sendPost } from '@utils/request';

export function getLogisticsList(data) {
  const url = '/trade/userOrderContract/logisticsList';
  return sendPost({ url, data });
}

export function getLogistics(data) {
  const url = '/trade/userOrderContract/logistics';
  return sendPost({ url, data });
}
